import http from 'utils/http';

export const getPickupInfo = (id, payload) => {
  return http.get(`/pickups/${id}`, payload);
};
